import { removeV2ScopeIndicator } from './isSensitiveScope';

/**
 * @deprecated this is now an internal function and should not be used outside of this package
 */
export const getScopeGroupI18nKey = (
  scopeGroup: string,
  key: 'label' | 'description' = 'label'
) => {
  const scopeGroupNameKey = removeV2ScopeIndicator(scopeGroup).replace(
    /\./g,
    '-'
  );
  return `developer-experience-shared-components.scopes.scopeGroups.${scopeGroupNameKey}.${key}`;
};
